// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a85ebdc5","453":"0cdc7fb2","455":"01244f92","977":"c56e4a38"}[chunkId] + ".chunk.js";
};